import { useMemo } from 'react';
import { IProductListItem } from 'api/types';
import { getProductLabels } from './productLabels';

/** Sprawdza, czy cena ma etykietę "twoja cena" lub "najlepsza cena" (niebieski styl) */
export const hasSpecialPriceLabel = (
  price: { price_label?: string } | undefined
): boolean =>
  price?.price_label === 'twoja cena' || price?.price_label === 'najlepsza cena';

export const useProductWithLabels = (product: IProductListItem) => {
  return useMemo(() => ({
    ...product,
    product_basic_short_info: {
      ...product.product_basic_short_info,
      labels: getProductLabels(product)
    }
  }), [product]);
};

